import apiClient from './apiClient'
import moment from 'moment'

export const actionNames = {
  INIT_OVERVIEW: 'initOverview',
  SET_SELECTED_PROJECT_ID: 'setSelectedProjectId'
}

export const module = {
  state: {
    numberOfCalls: null,
    averageResponseTime: null,
    ipBreakdown: null,
    langBreakdown: null,
    endpointBreakdown: null,
    averageCharacterCount: null,
    characterCount: null,
    usedQuota: 485257,
    quota: null,
    periodStartedAt: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    periodEndsAt: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
    from: '',
    to: '',
    selectedProjectId: 0
  },
  mutations: {
    setNumberOfCalls (state, numberOfCalls) {
      state.numberOfCalls = Object.entries(numberOfCalls).reduce((numCalls, [date, group]) => {
        return {
          ...numCalls,
          [Date.parse(date)]: group
        }
      }, {})
    },
    setAverageResponseTime (state, averageResponseTime) {
      state.averageResponseTime = Object.entries(averageResponseTime).reduce((averages, [date, average]) => {
        return {
          ...averages,
          [Date.parse(date)]: average.total
        }
      }, {})
    },
    setAverageCharacterCount (state, averageCharacterCount) {
      state.averageCharacterCount = Object.entries(averageCharacterCount).reduce((averages, [date, average]) => {
        return {
          ...averages,
          [Date.parse(date)]: average.total
        }
      }, {})
    },
    setCharacterCount (state, characterCount) {
      state.characterCount = Object.entries(characterCount).reduce((counts, [date, count]) => {
        return {
          ...counts,
          [Date.parse(date)]: count.total
        }
      }, {})
    },
    setIPBreakdown (state, ipBreakdown) {
      state.ipBreakdown = ipBreakdown
    },
    setLangBreakdown (state, langBreakdown) {
      state.langBreakdown = langBreakdown
    },
    setEndpointBreakdown (state, endpointBreakdown) {
      state.endpointBreakdown = endpointBreakdown
    },
    setUsedQuota (state, newUsedQuota) {
      state.usedQuota = newUsedQuota
    },
    setQuota (state, newQuota) {
      state.quota = newQuota
    },
    setDateInterval (state, dateRange) {
      state.from = moment(dateRange.startDate).format('YYYY-MM-DDT00:00:00.000')
      state.to = moment(dateRange.endDate).format('YYYY-MM-DDT23:59:59.000')
    },
    selectedProjectId (state, selectedProjectId) {
      state.selectedProjectId = selectedProjectId
    }
  },
  actions: {
    async [actionNames.INIT_OVERVIEW] ({ commit, state, rootState }) {
      const response = await apiClient.getNumberOfCalls(
        rootState.auth.clientId,
        state.selectedProjectId || undefined,
        apiClient.intervalOptions.DAY,
        state.from,
        state.to,
        apiClient.groupByOptions.STATUS_CODE
      )
      commit('setNumberOfCalls', response)
      commit(
        'setUsedQuota',
        Object.values(response).reduce((numCalls, day) => numCalls + (day && day['200'] ? day[200] : 0), 0)
      )
      commit('setAverageResponseTime', await apiClient.getAverageResponseTime(
        rootState.auth.clientId,
        state.selectedProjectId || undefined,
        apiClient.intervalOptions.DAY,
        state.from,
        state.to
      ))
      commit('setIPBreakdown', await apiClient.getCallBreakdown(
        rootState.auth.clientId,
        state.selectedProjectId || undefined,
        state.from,
        state.to,
        apiClient.groupByOptions.CLIENT_IP
      ))
      commit('setLangBreakdown', await apiClient.getCallBreakdown(
        rootState.auth.clientId,
        state.selectedProjectId || undefined,
        state.from,
        state.to,
        apiClient.groupByOptions.LANGUAGE
      ))
      commit('setEndpointBreakdown', await apiClient.getCallBreakdown(
        rootState.auth.clientId,
        state.selectedProjectId || undefined,
        state.from,
        state.to,
        apiClient.groupByOptions.PATH
      ))
      commit('setQuota', rootState.auth.quota)
      commit('setAverageCharacterCount', await apiClient.averageCharacterCount(
        rootState.auth.clientId,
        state.selectedProjectId || undefined,
        state.from,
        state.to
      ))
      commit('setCharacterCount', await apiClient.characterCount(
        rootState.auth.clientId,
        state.selectedProjectId || undefined,
        state.from,
        state.to
      ))
    },
    async [actionNames.SET_SELECTED_PROJECT_ID] ({ commit, dispatch }, projectId) {
      commit('selectedProjectId', projectId)
      await dispatch(actionNames.INIT_OVERVIEW)
    }
  }
}
